import {NgModule} from '@angular/core';
import {MedicalRecordGeneralInformationModule} from './medical-record/general-information/medicalRecordGeneralInformation.module';
import {MedicalRecordPractitionerModule} from './medical-record/practitioner/medicalRecordPractitioner.module';
import {MedicalRecordSportModule} from './medical-record/sport/medicalRecordSport.module';
import {MedicalRecordPainModule} from './medical-record/pain/medicalRecordPain.module';
import {MedicalRecordVisitReasonModule} from './medical-record/visit-reason/medicalRecordVisitReason.module';
import {MedicalRecordProblemModule} from './medical-record/problem/medicalRecordProblem.module';
import {MedicalChargedActModule} from './charged-act/medicalChargedAct.module';
import {MedicalReportModule} from './report/medicalReport.module';
import {MedicalTreatmentModule} from './treatment/medicalTreatment.module';
import {MedicalMorphologyModule} from './morphology/medicalMorphology.module';
import {PrescriptionModule} from './prescription/prescription.module';
import {ConsultationModule} from './consultation/consultation.module';
import {TeletransmissionModule} from "./teletransmission/teletransmission.module";
import {MedicalDeviceModule} from "./device/medicalDevice.module";
import {MedicalSterilizationModule} from "./sterilization/medicalSterilization.module";

@NgModule({
    imports: [
        MedicalRecordGeneralInformationModule,
        MedicalRecordPractitionerModule,
        MedicalRecordSportModule,
        MedicalRecordVisitReasonModule,
        MedicalRecordPainModule,
        MedicalRecordProblemModule,
        MedicalChargedActModule,
        MedicalReportModule,
        MedicalTreatmentModule,
        PrescriptionModule,
        ConsultationModule,
        MedicalMorphologyModule,
        TeletransmissionModule,
        MedicalDeviceModule,
        MedicalSterilizationModule
    ]
})
export class MedicalModule {}

